import React from 'react';
import { Breadcrumb, Alert, Tooltip, Button, Cascader, Select, Selector, Modal } from '@roo/roo';
import { connect } from 'react-redux';
import { getCookie } from '@utiljs/cookie';
import Region from '@/components/Region/index2';
import request from '@/utils/request';
import utils from '@/utils/utils';
import regionUtil from '@/utils/region';
import './addSendGoods.scss';

interface IState {
    dispatchTemplateInfoId: number | string;
    providerId: number | string;
    provinceId: number | string;
    provinceName: string;
    cityId: number | string;
    cityName: string;
    districtId: number | string;
    districtName: string;
    tooltipVisble: boolean;
    provinceList: Array<any>; // 一级城市列表
    provinceValue: Array<number>;
    dispatchStartTime: number | string; // 发货时间
    logisticsCompany: Array<urls.goods.Express>; // 所有快递公司
    checkedCompany: Array<string>; // 已选快递公司stdCode
    dispatchLogisticsCompanyInfo: Array<urls.goods.ExpressCompany>; // 快递公司对应发货地区列表
    selectCityVisible: boolean;
    regionProvinceList: urls.freight.IprovinceInfo[];
    selectCityIndex: number;
    allCities: urls.freight.Icity[];
    cannotDeliveryCityList: urls.freight.Icity[];
    isEdit: boolean;
    submitLoading: boolean;
}

interface IProps {
    history: any;
    editData: any;
}

class SendGoods extends React.Component<IProps, IState> {
    selectCityRef: any;

    constructor(props: IProps) {
        super(props);
        const urlObj: any = utils.urlParse();

        this.state = {
            dispatchTemplateInfoId: urlObj.templateId || 0, // long 发货配置模版id
            isEdit: !!urlObj.templateId,
            providerId: +getCookie('serviceProviderID'), // 服务商ID
            provinceId: '', // 省份ID
            provinceName: '',
            cityId: '',
            cityName: '',
            districtId: '', // 区县ID
            districtName: '',
            dispatchStartTime: '', // int 发货时长
            tooltipVisble: false,
            provinceList: [], // 下拉选择-发货地区
            provinceValue: [], // 下拉选择-选择的value
            logisticsCompany: [], // 物流公司列表
            checkedCompany: [],
            dispatchLogisticsCompanyInfo: [],
            selectCityVisible: false,
            selectCityIndex: 0, // 操作的第发货区域
            regionProvinceList: [],
            allCities: [],
            cannotDeliveryCityList: [],
            submitLoading: false,
        };
    }

    async componentDidMount() {
        const { state, props } = this;
        // 快递公司列表
        const data = await request.get('/api/order/queryLogisticsCompany');
        // 发货地区第一级省份列表
        const provinceRes = await request.get('/api/city/provinceList');
        const logisticsCompany: any = [];
        let provinceList: any = [];
        data.data.forEach((company: any) => {
            logisticsCompany.push({
                expressCode: company.expressCode,
                expressName: company.expressName,
            });
        });
        provinceList = provinceRes.data.map((city: any) => ({
            ...city,
            isLeaf: false,
            level: 1,
        }));

        this.setState({
            logisticsCompany,
            provinceList,
        });

        // 选择城市区域数据
        request.get('/api/city/provinceGroup').then((res: any) => {
            if (res.code === 0) {
                const allCities: any = [];
                res.data.forEach((item: any) => {
                    item.cityList.forEach((city: any) => {
                        allCities.push(city);
                    });
                });
                this.setState({
                    regionProvinceList: res.data,
                    allCities,
                    cannotDeliveryCityList: state.isEdit ? this.state.cannotDeliveryCityList : [], // 第一次初始化的时候显示空
                });
                this.setEditCity();
            }
        });

        // 编辑的话，回填数据
        const editData = props.editData || {};
        if (state.isEdit) {
            const checkedCompany = editData.dispatchLogisticsCompanyInfo.map(
                (item: any) => item.logisticsCompanyStdCode,
            );
            this.setState({
                ...editData,
                checkedCompany,
                provinceValue: [editData.provinceId, editData.cityId, editData.districtId],
            });
        }
    }

    // 修改发货地区
    handleCityChange = async (value: number[], selectedOptions: any[]) => {
        this.setState({
            provinceValue: value,
            provinceId: selectedOptions[0].cityId,
            provinceName: selectedOptions[0].cityName,
            cityId: selectedOptions[1].cityId,
            cityName: selectedOptions[1].cityName,
            districtId: selectedOptions[2].cityId,
            districtName: selectedOptions[2].cityName,
        });
    };

    getSubCity = async (cityId: string) => {
        const info = await request.post('/api/city/subCityInfo/get', { cityIds: [cityId] });
        return info;
    };

    // 触发下一级菜单
    handleLoadData = async (item: any) => {
        item.loading = true;
        if (!item.isLeaf) {
            const res = await this.getSubCity(item.cityId);
            item.loading = false;
            let { cityList } = res.data[0];
            if (item.level === 1) {
                cityList = cityList.map((city: any) => ({
                    ...city,
                    level: 2,
                    isLeaf: false,
                }));
            } else {
                cityList = cityList.map((city: any) => ({
                    ...city,
                    level: 3,
                    isLeaf: true,
                }));
            }
            item.children = cityList;
            this.setState({
                provinceList: this.state.provinceList,
            });
        }
    };

    // 设置发货时间
    handleDispatchStartTime = (val: number) => {
        this.setState({
            dispatchStartTime: val,
        });
    };

    // 选择物流公司，同时设置配送地区数据，增加、删除都是此处
    handleLogisticsCompany = (val: Array<string>) => {
        const { state } = this;
        const dispatchLogisticsCompanyInfo = utils.simpleCopy(state.dispatchLogisticsCompanyInfo);
        const newDispatchLogisticsCompanyInfo: any = [];

        val.forEach(expressCode => {
            const exist = dispatchLogisticsCompanyInfo.find(
                (item: any) => item.logisticsCompanyStdCode === expressCode,
            );
            // 如果存在，则保留；否则新增。其他没遍历到了，就是删除
            if (exist) {
                newDispatchLogisticsCompanyInfo.push(exist);
            } else {
                const express: any = state.logisticsCompany.find(
                    (company: any) => company.expressCode === expressCode,
                );
                newDispatchLogisticsCompanyInfo.push({
                    logisticsCompanyStdCode: express.expressCode,
                    logisticsCompanyName: express.expressName,
                    cityList: [],
                });
            }
        });
        this.setState({
            checkedCompany: val,
            dispatchLogisticsCompanyInfo: newDispatchLogisticsCompanyInfo,
            cannotDeliveryCityList: regionUtil.getTargetCities(
                state.allCities,
                this.getDispatchCities(newDispatchLogisticsCompanyInfo),
            ),
        });
    };

    // 用户端信息显示示意图
    handleKnowClick = () => {
        this.setState(state => ({
            tooltipVisble: !state.tooltipVisble,
        }));
    };

    setEditCity = async () => {
        const { state, props } = this;
        const editData = props.editData || {};
        // 编辑的时候，请求市、区信息
        if (state.isEdit) {
            const res1 = await this.getSubCity(editData.provinceId);
            const res2 = await this.getSubCity(editData.cityId);
            const provinceList = utils.simpleCopy(state.provinceList);

            const cityList1 = res1.data[0].cityList.map((city: any) => ({
                ...city,
                level: 2,
                isLeaf: false,
            }));
            const index1 = provinceList.findIndex(
                (city: any) => city.cityId === editData.provinceId,
            );
            provinceList[index1].children = cityList1;

            const cityList2 = res2.data[0].cityList.map((city: any) => ({
                ...city,
                level: 3,
                isLeaf: true,
            }));
            const index2 = res1.data[0].cityList.findIndex(
                (city: any) => city.cityId === editData.cityId,
            );
            provinceList[index1].children[index2].children = cityList2;

            this.setState({
                provinceList,
            });
        }
    };

    getItems = () => {
        const { isEdit } = this.state;
        return [
            {
                text: '发货设置',
                onClick: () => {
                    this.props.history.push('/freight/list?type=2');
                },
            },
            {
                text: `${isEdit ? '编辑' : '新建'}发货设置`,
            },
        ];
    };

    // 选择地区-确认
    handleSelectCity = () => {
        const { state } = this;
        const cities: any = this.selectCityRef.getSelectedCities();
        const companyInfo = utils.simpleCopy(state.dispatchLogisticsCompanyInfo);
        const info = companyInfo[state.selectCityIndex];
        info.cityList = cities;
        this.setState({
            dispatchLogisticsCompanyInfo: companyInfo,
            selectCityVisible: false,
            cannotDeliveryCityList: regionUtil.getTargetCities(
                state.allCities,
                this.getDispatchCities(companyInfo),
            ),
        });
    };

    getDispatchCities = (dispatchLogisticsCompanyInfo?: any) => {
        const { state } = this;
        let cities: any = [];
        (dispatchLogisticsCompanyInfo || state.dispatchLogisticsCompanyInfo).forEach(
            (item: any) => {
                cities = cities.concat(item.cityList);
            },
        );
        return cities;
    };

    // 其他物流已经选择的地区不能再选择
    getDisabledCity = () => {
        const { state } = this;
        let disabledCity: any = [];
        state.dispatchLogisticsCompanyInfo.forEach((item, index) => {
            if (index !== state.selectCityIndex) {
                disabledCity = disabledCity.concat(item.cityList);
            }
        });
        return disabledCity;
    };

    // 最后确认提交
    handleSubmit = async () => {
        const { state, props } = this;
        // 校验
        if (!state.districtId) {
            return utils.toast('warn', '请填写发货地区');
        }
        if (!state.dispatchStartTime) {
            return utils.toast('warn', '请填写发货时间');
        }
        if (state.checkedCompany.length === 0) {
            return utils.toast('warn', '请填写合作物流公司');
        }
        let valid = true;
        state.dispatchLogisticsCompanyInfo.forEach(info => {
            if (info.cityList.length === 0) {
                valid = false;
            }
        });
        if (!valid) {
            return utils.toast('warn', '请填写完整物流公司配送地区');
        }
        this.setState({
            submitLoading: true,
        });
        const params = {
            dispatchTemplateInfoId: state.dispatchTemplateInfoId,
            providerId: state.providerId,
            provinceId: state.provinceId,
            provinceName: state.provinceName,
            cityId: state.cityId,
            cityName: state.cityName,
            districtId: state.districtId,
            districtName: state.districtName,
            dispatchStartTime: state.dispatchStartTime,
            dispatchLogisticsCompanyInfo: state.dispatchLogisticsCompanyInfo,
            cannotDeliveryCityList: state.cannotDeliveryCityList,
        };
        const res = await request.post('/api/dispatchTemplates/addOrUpdate', params, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        this.setState({
            submitLoading: false,
        });
        if (res.code === 0) {
            props.history.push('/freight/list?type=2');
        }
        return res;
    };

    render() {
        const { state } = this;
        const {
            isEdit,
            tooltipVisble,
            dispatchStartTime,
            logisticsCompany,
            checkedCompany,
            dispatchLogisticsCompanyInfo,
            provinceList,
            cannotDeliveryCityList,
        } = this.state;

        return (
            <div className="add-sendgoods">
                <Breadcrumb type="oblique" items={this.getItems()} />
                <div className="title20">{`${isEdit ? '编辑' : '新建'}发货模版`}</div>
                <Alert
                    style={{ width: '800px', height: '37px', marginBottom: 30 }}
                    title="说明：为了让用户在下单前对商品送达日期有一个相对准确的预期，希望您如实填写以下信息"
                    icon="roo-icon-info-circle"
                    extra={
                        <Tooltip
                            placement="bottom"
                            manual
                            visible={tooltipVisble}
                            content={
                                <div
                                    style={{
                                        display: 'inline-block',
                                        textAlign: 'center',
                                        minHeight: 260,
                                    }}
                                >
                                    <img
                                        style={{ width: '100%' }}
                                        src={require('@/assets/images/tip.png')}
                                    />
                                    <Button onClick={this.handleKnowClick}>我知道了</Button>
                                </div>
                            }
                            effect="light"
                            style={{ color: '#00abe4' }}
                        >
                            <Button onClick={this.handleKnowClick} type="text">
                                用户端信息显示示意图
                            </Button>
                        </Tooltip>
                    }
                />
                {/* 发货地区 */}
                <div className="block_style flex-vertical-center">
                    <div className="block_label">发货地区</div>
                    <div className="block_content">
                        <Cascader
                            value={state.provinceValue}
                            options={provinceList}
                            loadData={this.handleLoadData}
                            fieldNames={{
                                label: 'cityName',
                                value: 'cityId',
                                children: 'children',
                            }}
                            onChange={this.handleCityChange}
                            placeholder="请选择地区"
                        />
                    </div>
                </div>
                {/* 发货时间 */}
                <div className="block_style flex-vertical-center">
                    <div className="block_label">发货时间</div>
                    <div className="block_content flex-vertical-center">
                        <div className="child_label">用户下单后</div>
                        <div className="child_content">
                            <Select
                                placeholder="请选择时间"
                                options={regionUtil.dispatchOptions}
                                value={dispatchStartTime}
                                onChange={this.handleDispatchStartTime}
                            />
                        </div>
                    </div>
                </div>
                {/* 合作物流公司 */}
                <div className="block_style flex-vertical-center">
                    <div className="block_label1">合作物流公司</div>
                    <div className="block_content" style={{ width: '460px' }}>
                        <Selector
                            style={{ width: '400px' }}
                            options={logisticsCompany}
                            placeholder="请选择物流公司"
                            multiple
                            clearable
                            value={checkedCompany}
                            fieldNames={{ label: 'expressName', value: 'expressCode' }}
                            onChange={this.handleLogisticsCompany}
                        />
                        <div className="note_style">
                            注：请选择您合作的物流公司，系统会根据您选择的物流公司，自动计算送达时效。
                        </div>
                    </div>
                </div>
                {/* 物流公司配送地区 */}
                <div className="block_style" style={{ fontWeight: 500, marginTop: 60 }}>
                    物流公司配送地区
                </div>
                <div>
                    {dispatchLogisticsCompanyInfo.map((item: any, index: number) => {
                        const { logisticsCompanyStdCode, logisticsCompanyName, cityList } = item;
                        return (
                            <div
                                key={logisticsCompanyStdCode}
                                className="region_block flex-vertical-start"
                            >
                                <div className="item_label">
                                    {`由${logisticsCompanyName}配送的地区:`}
                                </div>
                                <div className="item-content">
                                    {cityList.length > 0 && (
                                        <div style={{ paddingBottom: '15px' }}>
                                            {cityList.map((city: any) => city.cityName).join('、')}
                                        </div>
                                    )}
                                    <Button
                                        type="hollow"
                                        onClick={() => {
                                            this.setState({
                                                selectCityVisible: true,
                                                selectCityIndex: index,
                                            });
                                        }}
                                    >
                                        添加配送地区
                                    </Button>
                                </div>
                            </div>
                        );
                    })}
                    <div className="region_block flex-vertical-start">
                        <div className="item_label">不配送的地区:</div>
                        <div className="item-content">
                            {cannotDeliveryCityList.length > 0 ? (
                                <div style={{ paddingBottom: '15px' }}>
                                    {cannotDeliveryCityList
                                        .map((city: any) => city.cityName)
                                        .join('、')}
                                </div>
                            ) : (
                                <div>无</div>
                            )}
                        </div>
                    </div>
                </div>
                <div className="block_style" style={{ marginTop: 40 }}>
                    <Button
                        type="hollow"
                        onClick={() => {
                            this.props.history.push('/freight/list?type=2');
                        }}
                    >
                        取消
                    </Button>
                    <Button
                        style={{ marginLeft: 10 }}
                        onClick={this.handleSubmit}
                        loading={state.submitLoading}
                    >
                        确定
                    </Button>
                </div>
                {/* 选择区域弹框 */}
                <Modal
                    visible={state.selectCityVisible}
                    backdropClosable={false}
                    title="请选择地区"
                    size="lg"
                    onCancel={() => {
                        this.setState({
                            selectCityVisible: false,
                        });
                    }}
                    onConfirm={this.handleSelectCity}
                >
                    <Region
                        controlled={false}
                        ref={(ref: any) => {
                            this.selectCityRef = ref;
                        }}
                        provinceList={state.regionProvinceList}
                        defaultCheckedCity={
                            state.dispatchLogisticsCompanyInfo[state.selectCityIndex]
                                ? state.dispatchLogisticsCompanyInfo[state.selectCityIndex].cityList
                                : []
                        }
                        disabledCity={this.getDisabledCity()}
                    />
                </Modal>
            </div>
        );
    }
}

function mapStateToProps(state: any) {
    const { freight } = state;
    return {
        ...freight,
    };
}

export default connect(mapStateToProps)(SendGoods);
